import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import type { ReactNode } from 'react'

const { Title, Text } = Typography

interface PageShellProps {
  children: ReactNode
  width?: 'default' | 'narrow' | 'wide' | 'full'
  className?: string
}

interface PageHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  extra?: ReactNode
  meta?: ReactNode
  onBack?: () => void
  backLabel?: string
}

export function PageShell({ children, width = 'default', className }: PageShellProps) {
  const classes = ['app-page', `app-page--${width}`, className].filter(Boolean).join(' ')
  return <section className={classes}>{children}</section>
}

export function PageHeader({
  title,
  subtitle,
  extra,
  meta,
  onBack,
  backLabel = '返回'
}: PageHeaderProps) {
  return (
    <header className="app-page-header">
      <div className="app-page-header__main">
        {onBack ? (
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            className="app-page-header__back"
            aria-label={backLabel}
          />
        ) : null}

        <div className="app-page-header__copy">
          <div className="app-page-header__title-row">
            <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
              {title}
            </Title>
          </div>

          {subtitle ? (
            <Text className="app-page-header__subtitle" type="secondary">
              {subtitle}
            </Text>
          ) : null}

          {meta ? <div className="app-page-header__meta">{meta}</div> : null}
        </div>
      </div>

      {extra ? <div className="app-page-header__extra">{extra}</div> : null}
    </header>
  )
}
